Eve User AutoComplete





<p-autoComplete [ngModel]="selectedEveUsers" (ngModelChange)="onModelChange($event)" [suggestions]="eveUsers" (completeMethod)="search($event)" multiple="true" field="eveUserName">
  <ng-template let-eveUser pTemplate="item">
    <div class="country-item">
      <!--<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country" />-->
      <!--<mat-icon class="mat-icon-widget-type-button flag">speed</mat-icon>-->
      <img src="{{baseHref}}Library/GetUserAvatar?libraryId={{eveUser.avatarImageId ?? -1}}" class="flag" />
      
      <div>{{eveUser.eveUserName}}</div>
    </div>
  </ng-template>
</p-autoComplete>
